import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=d0bd45f8&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=js"
export * from "./TemplatePicker.vue?vue&type=script&lang=js"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=d0bd45f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bd45f8",
  null
  
)

export default component.exports